// extracted by mini-css-extract-plugin
export default {"container":"CrossRates_container__+WHUi","tvcontainer":"CrossRates_tvcontainer__C1B9y"};